import type { TOC } from '@ember/component/template-only';
import { PrismButton } from '@mylighthouse/prism-ember';
import { ICONS_LOGOS_MAP } from '@mylighthouse/prism-foundation';
import { t } from 'ember-intl';
import { FocusScreen } from 'frontend-utils';
import HotelBenchmarkInsightCompetitorsCompsetBuilderCompsetBuilderHeader from 'lumen/components/hotel/benchmark-insight/competitors/compset-builder/compset-builder-header';
import type HotelSettingsCompetitorsBenchmarkCompsetBuilderGenerateController from 'lumen/controllers/hotel/settings/competitors/benchmark/compset/builder/generate';
import importAsset from 'lumen/helpers/import-asset';
import lottieAnimation from 'lumen/modifiers/lottie-animation';

interface HotelSettingsCompetitorsBenchmarkCompsetBuilderGenerateSignature {
  Args: {
    controller: HotelSettingsCompetitorsBenchmarkCompsetBuilderGenerateController;
    model: unknown;
  };
}

<template>
  <FocusScreen
    @hasCancel={{true}}
    @isCancelDisabled={{false}}
    @logoHtml={{ICONS_LOGOS_MAP.logo-dark-with-text}}
    @onClose={{@controller.onClose}}
    @size="large"
  >
    <:header>
      <HotelBenchmarkInsightCompetitorsCompsetBuilderCompsetBuilderHeader
        @currentStep={{2}}
      />
    </:header>
    <:body>
      <div
        class="compset-builder__body flex h-full w-full flex-col items-center justify-center gap-800 p-1000"
      >
        <div
          {{lottieAnimation
            (importAsset
              "animations/benchmark-insight/smart-compset-builder-validation.json"
            )
            true
          }}
        />

        <div class="flex flex-col items-center gap-200">
          <h2>{{t
              "settings.competitors.benchmark.compset.builder.generate.title"
            }}</h2>
          <p class="text-300--regular text-neutral-subdued">{{t
              "settings.competitors.benchmark.compset.builder.generate.description"
            }}</p>
        </div>
      </div>
    </:body>
    <:footer>
      <div class="flex w-full flex-row justify-end gap-300">
        <PrismButton
          @buttonType="brand"
          @iconAfter="arrow-right"
          @isDisabled={{true}}
          @label={{t "general.next"}}
        />
      </div>

    </:footer>
  </FocusScreen>
</template> satisfies TOC<HotelSettingsCompetitorsBenchmarkCompsetBuilderGenerateSignature>;
